import { CommitmentAccount } from "../../../../../../../../services/cloudchipr.api";

export const isCommitmentAccount = (value: any): value is CommitmentAccount => {
  return (
    value === null || value?.id || value?.provider_account_id || value?.name
  );
};
